import { IonCol, IonLabel, IonRow } from "@ionic/react";
import BlueCheckSvg from "@src/assets/icons/blue-check.svg";
import { Shift } from "@src/lib/interface/src";

import { NegotiationActionButton } from "./Buttons/NegotiationActionButton";
import { ProposeNewInfoButtons } from "./Buttons/ProposeNewInfoButtons";
import { NegotiationStatus, RateNegotiationHistoryResponse } from "./interfaces";

interface Props {
  shift: Shift;
  negotiationHistory: RateNegotiationHistoryResponse[];
  workApproved: boolean;
  closeModal: () => void;
  isWorkerProposing: boolean;
  showCommitModal: (_: any) => void;
  loadAlertDialog: (callback?: () => void) => void;
  pageLoading: boolean;
  isLoadingShiftBook?: boolean;
  proposeButtonText: string;
  onClickProposeButton: () => void;
  handleEndNegotiation: () => Promise<void>;
}

export function NegotiationToolFooter(props: Props) {
  const {
    shift,
    negotiationHistory,
    workApproved,
    closeModal,
    isWorkerProposing,
    showCommitModal,
    loadAlertDialog,
    pageLoading,
    isLoadingShiftBook,
    proposeButtonText,
    onClickProposeButton,
    handleEndNegotiation,
  } = props;

  if (workApproved || shift?.rateNegotiation?.status === NegotiationStatus.ACCEPTED) {
    return (
      <IonRow>
        <IonCol size="12" className="shift-item__work-confirmed">
          <IonLabel className="ion-label">
            <img src={BlueCheckSvg} alt="" />
            You&apos;re Working This Shift!
          </IonLabel>
        </IonCol>
      </IonRow>
    );
  }
  if (shift?.rateNegotiation?.status && shift?.rateNegotiation?.status !== NegotiationStatus.OPEN) {
    return (
      <NegotiationActionButton onClick={closeModal} className="close_tool">
        Close
      </NegotiationActionButton>
    );
  }
  return (
    <ProposeNewInfoButtons
      onClickProposeButton={onClickProposeButton}
      shift={shift}
      negotiationHistory={negotiationHistory}
      isWorkerProposing={isWorkerProposing}
      showCommitModal={showCommitModal}
      loadAlertDialog={loadAlertDialog}
      pageLoading={pageLoading}
      isLoadingShiftBook={isLoadingShiftBook}
      proposeButtonText={proposeButtonText}
      handleEndNegotiation={handleEndNegotiation}
    />
  );
}
